/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CART_ITEMS_PAGINATION_ARGUMENTS } from '@/cart/api/graphql/arguments';
import { CART_FRAGMENT } from '@/cart/api/graphql/CartFragment';

import { CUSTOMER_ACCOUNT_FRAGMENT } from '@/cart/api/graphql/CustomerAccountFragment';

export const GUEST_CART_QUERY = `
  query GUEST_CART_QUERY(
      $cartId: String!,
      ${CART_ITEMS_PAGINATION_ARGUMENTS}
    ) {

    cart(cart_id: $cartId){
      ...CART_FRAGMENT
    }
  }

  ${CART_FRAGMENT}
`;

export const CUSTOMER_CART_QUERY = `
  query CUSTOMER_CART_QUERY(
      ${CART_ITEMS_PAGINATION_ARGUMENTS}
    ) {
     
    customer {
      ...CUSTOMER_FRAGMENT
    }

    cart: customerCart {
      ...CART_FRAGMENT
    }
  }

  ${CUSTOMER_ACCOUNT_FRAGMENT}
  ${CART_FRAGMENT}
`;
